export class ConfigGeoRegions
{
    /**
     * Regions by country for dropdowns.
     * Referenced Updates: https://www.faa.gov/air_traffic/publications/atpubs/cnt_html/appendix_a.html
     * @type {{country: string, regions: string[]}[]}
     */
    public static RegionsByCountry: {
        country: string,
        regions: {
            countryCode: string,
            region: string,
            abbreviation?: string;
        }[]
    }[] = [
        {
            country: 'U.S.',
            regions: [
                // states
                {countryCode: 'US', region: 'Alabama', abbreviation: 'AL'},
                {countryCode: 'US', region: 'Alaska', abbreviation: 'AK'},
                {countryCode: 'US', region: 'Arizona', abbreviation: 'AZ'},
                {countryCode: 'US', region: 'Arkansas', abbreviation: 'AR'},
                {countryCode: 'US', region: 'California', abbreviation: 'CA'},
                {countryCode: 'US', region: 'Colorado', abbreviation: 'CO'},
                {countryCode: 'US', region: 'Connecticut', abbreviation: 'CT'},
                {countryCode: 'US', region: 'Delaware', abbreviation: 'DE'},
                {countryCode: 'US', region: 'Florida', abbreviation: 'FL'},
                {countryCode: 'US', region: 'Georgia', abbreviation: 'GA'},
                {countryCode: 'US', region: 'Hawaii', abbreviation: 'HI'},
                {countryCode: 'US', region: 'Idaho', abbreviation: 'ID'},
                {countryCode: 'US', region: 'Illinois', abbreviation: 'IL'},
                {countryCode: 'US', region: 'Indiana', abbreviation: 'IN'},
                {countryCode: 'US', region: 'Iowa', abbreviation: 'IA'},
                {countryCode: 'US', region: 'Kansas', abbreviation: 'KS'},
                {countryCode: 'US', region: 'Kentucky', abbreviation: 'KY'},
                {countryCode: 'US', region: 'Louisiana', abbreviation: 'LA'},
                {countryCode: 'US', region: 'Maine', abbreviation: 'ME'},
                {countryCode: 'US', region: 'Maryland', abbreviation: 'MD'},
                {countryCode: 'US', region: 'Massachusetts', abbreviation: 'MA'},
                {countryCode: 'US', region: 'Michigan', abbreviation: 'MI'},
                {countryCode: 'US', region: 'Minnesota', abbreviation: 'MN'},
                {countryCode: 'US', region: 'Mississippi', abbreviation: 'MS'},
                {countryCode: 'US', region: 'Missouri', abbreviation: 'MO'},
                {countryCode: 'US', region: 'Montana', abbreviation: 'MT'},
                {countryCode: 'US', region: 'Nebraska', abbreviation: 'NE'},
                {countryCode: 'US', region: 'Nevada', abbreviation: 'NV'},
                {countryCode: 'US', region: 'New Hampshire', abbreviation: 'NH'},
                {countryCode: 'US', region: 'New Jersey', abbreviation: 'NJ'},
                {countryCode: 'US', region: 'New Mexico', abbreviation: 'NM'},
                {countryCode: 'US', region: 'New York', abbreviation: 'NY'},
                {countryCode: 'US', region: 'North Carolina', abbreviation: 'NC'},
                {countryCode: 'US', region: 'North Dakota', abbreviation: 'ND'},
                {countryCode: 'US', region: 'Ohio', abbreviation: 'OH'},
                {countryCode: 'US', region: 'Oklahoma', abbreviation: 'OK'},
                {countryCode: 'US', region: 'Oregon', abbreviation: 'OR'},
                {countryCode: 'US', region: 'Pennsylvania', abbreviation: 'PA'},
                {countryCode: 'US', region: 'Rhode Island', abbreviation: 'RI'},
                {countryCode: 'US', region: 'South Carolina', abbreviation: 'SC'},
                {countryCode: 'US', region: 'South Dakota', abbreviation: 'SD'},
                {countryCode: 'US', region: 'Tennessee', abbreviation: 'TN'},
                {countryCode: 'US', region: 'Texas', abbreviation: 'TX'},
                {countryCode: 'US', region: 'Utah', abbreviation: 'UT'},
                {countryCode: 'US', region: 'Vermont', abbreviation: 'VT'},
                {countryCode: 'US', region: 'Virginia', abbreviation: 'VA'},
                {countryCode: 'US', region: 'Washington', abbreviation: 'WA'},
                {countryCode: 'US', region: 'West Virginia', abbreviation: 'WV'},
                {countryCode: 'US', region: 'Wisconsin', abbreviation: 'WI'},
                {countryCode: 'US', region: 'Wyoming', abbreviation: 'WY'},

                // federal districts and territories
                {countryCode: 'US', region: 'District of Columbia', abbreviation: 'DC'},
                {countryCode: 'US', region: 'American Samoa', abbreviation: 'AS'},
                {countryCode: 'US', region: 'Federated States of Micronesia', abbreviation: 'FSM'},
                {countryCode: 'US', region: 'Guam', abbreviation: 'GU'},
                {countryCode: 'US', region: 'Northern Mariana Islands', abbreviation: 'MP'},
                {countryCode: 'US', region: 'Puerto Rico', abbreviation: 'PR'},
                {countryCode: 'US', region: 'Virgin Islands', abbreviation: 'VI'},
                {countryCode: 'US', region: 'Trust Territories', abbreviation: 'TT'},
            ],
        },
        {
            // military codes: Armed Forces of the Americas, Armed Forces of Europe, and Armed Forces of the Pacific
            country: 'U.S. Armed Forces',
            regions: [
                {countryCode: 'US', region: 'Armed Forces (Americas)', abbreviation: 'AA'},
                {countryCode: 'US', region: 'Armed Forces (Europe)', abbreviation: 'AE'},
                {countryCode: 'US', region: 'Armed Forces (Pacific)', abbreviation: 'AP'},
            ],
        },
        {
            country: 'Mexico',
            regions: [
                {countryCode: 'MX', region: 'Aguascalientes'},
                {countryCode: 'MX', region: 'Baja California'},
                {countryCode: 'MX', region: 'Baja California Sur'},
                {countryCode: 'MX', region: 'Chihuahua'},
                {countryCode: 'MX', region: 'Colima'},
                {countryCode: 'MX', region: 'Campeche'},
                {countryCode: 'MX', region: 'Coahuila'},
                {countryCode: 'MX', region: 'Chiapas'},
                {countryCode: 'MX', region: 'Federal District'},
                {countryCode: 'MX', region: 'Durango'},
                {countryCode: 'MX', region: 'Guerrero'},
                {countryCode: 'MX', region: 'Guanajuato'},
                {countryCode: 'MX', region: 'Hidalgo'},
                {countryCode: 'MX', region: 'Jalisco'},
                {countryCode: 'MX', region: 'México State'},
                {countryCode: 'MX', region: 'Michoacán'},
                {countryCode: 'MX', region: 'Morelos'},
                {countryCode: 'MX', region: 'Nayarit'},
                {countryCode: 'MX', region: 'Nuevo León'},
                {countryCode: 'MX', region: 'Oaxaca'},
                {countryCode: 'MX', region: 'Puebla'},
                {countryCode: 'MX', region: 'Querétaro'},
                {countryCode: 'MX', region: 'Quintana Roo'},
                {countryCode: 'MX', region: 'Sinaloa'},
                {countryCode: 'MX', region: 'San Luis Potosí'},
                {countryCode: 'MX', region: 'Sonora'},
                {countryCode: 'MX', region: 'Tabasco'},
                {countryCode: 'MX', region: 'Tlaxcala'},
                {countryCode: 'MX', region: 'Tamaulipas'},
                {countryCode: 'MX', region: 'Veracruz'},
                {countryCode: 'MX', region: 'Yucatán'},
                {countryCode: 'MX', region: 'Zacatecas'},
            ],
        },
        {
            country: 'Canada',
            regions: [
                {countryCode: 'CA', region: 'Alberta'},
                {countryCode: 'CA', region: 'British Columbia'},
                {countryCode: 'CA', region: 'Manitoba'},
                {countryCode: 'CA', region: 'New Brunswick'},
                {countryCode: 'CA', region: 'Newfoundland and Labrador'},
                {countryCode: 'CA', region: 'Northwest Territories'},
                {countryCode: 'CA', region: 'Nova Scotia'},
                {countryCode: 'CA', region: 'Nunavut'},
                {countryCode: 'CA', region: 'Ontario'},
                {countryCode: 'CA', region: 'Prince Edward Island'},
                {countryCode: 'CA', region: 'Quebec'},
                {countryCode: 'CA', region: 'Saskatchewan'},
                {countryCode: 'CA', region: 'Yukon'},
            ],
        },
        {
            country: 'Costa Rica',
            regions: [
                {countryCode: 'CR', region: 'Alajuela'},
                {countryCode: 'CR', region: 'Cartago'},
                {countryCode: 'CR', region: 'Guanacaste'},
                {countryCode: 'CR', region: 'Limon'},
                {countryCode: 'CR', region: 'Puntarenas'},
                {countryCode: 'CR', region: 'San Jose'},
            ],
        },
    ];

    /**
     * @param {{countryCode: string, region: string}} region
     * @returns {{countryCode: string, region: string}}
     */
    public static findRegion(region: { countryCode: string, region: string }): { countryCode: string, region: string } {
        for (let c: number = 0; c < ConfigGeoRegions.RegionsByCountry.length; c++) {
            if (ConfigGeoRegions.RegionsByCountry[c].regions[0].countryCode !== region.countryCode) {
                continue;
            }
            for (let r: number = 0; r < ConfigGeoRegions.RegionsByCountry[c].regions.length; r++) {
                const candidate = ConfigGeoRegions.RegionsByCountry[c].regions[r];
                if (candidate.region === region.region || candidate.abbreviation === region.region) {
                    return ConfigGeoRegions.RegionsByCountry[c].regions[r];
                }
            }
        }

        return null;
    }

    /**
     * Reverse-lookup of a full region name → its 2-letter abbreviation. Useful when the
     * stored value is the long name (e.g. organization_profiles.state) but the UI needs
     * the short form for a tight column. Falls back to the input when no mapping exists.
     */
    public static getRegionAbbreviation(region: string | null | undefined): string | null {
        if (!region) {
            return region ?? null;
        }
        for (const country of ConfigGeoRegions.RegionsByCountry) {
            for (const r of country.regions) {
                if (r.region === region && r.abbreviation) {
                    return r.abbreviation;
                }
            }
        }

        return region;
    }
}
